import React, { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { useSidebar } from '../../context/SidebarContext';
import SidePanel from '../Common/SidePanel';
import MobileMenuToggle from '../Common/MobileMenuToggle';
import AdminDashboard from './AdminDashboard';
import VehicleExecutiveDashboard from './VehicleExecutiveDashboard';
import ServiceEngineerDashboard from './ServiceEngineerDashboard';

const Dashboard = () => {
  const { user } = useContext(AuthContext);
  const { isCollapsed } = useSidebar();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const renderDashboard = () => {
    switch (user?.role) {
      case 'ADMIN':
        return <AdminDashboard />;
      case 'VEHICLE_EXECUTIVE':
        return <VehicleExecutiveDashboard />;
      case 'SERVICE_ENGINEER':
        return <ServiceEngineerDashboard />;
      default:
        return <div className="text-center py-12">Unknown role</div>;
    }
  };

  return (
    <div className="flex h-screen bg-slate-50">
      <MobileMenuToggle onClick={() => setIsSidebarOpen(true)} isSidebarOpen={isSidebarOpen} />
      <SidePanel isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      <div className="flex-1 flex flex-col overflow-hidden transition-all duration-300">
        <main className="flex-1 overflow-y-auto pt-28 md:pt-0">
          <div className="p-6 md:p-8 max-w-7xl mx-auto">{renderDashboard()}</div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
